module.exports = __webpack_public_path__ + "static/media/upload.9a4cb627.svg";